import React, { Component } from "react";
import Hero from './../../alpineComponents/hero';
import TextOverImageThumb from './../../alpineComponents/textOverImageThumb';
import TextAndImage from './../../alpineComponents/textAndImage';
import VideoBox from './../../alpineComponents/videoBox';
import CenteredParagraph from './../../alpineComponents/centeredParagraph';
import { Link } from "react-router-dom";
import  './../../utils/analytics';


export default class extends Component {
  render() {
    return (
		<div className="light-grey-background">
      <Hero
        extraClassName={'home-full'}
				subtitle={'PILATES AVENUE'}
				title={'the place for classical pilates'}
				backgroundImage={'images/index-hero.jpg'}
				height={'full'} /*full, half,threequarter*/
        subtitlePosition={'top'}
      />
      <div className="row" style={{padding:'2px'}}>
        <div className="small-12 medium-3" style={{padding:'2px'}}>
          <TextOverImageThumb
            text="Studio Services & Rates"
            image={'images/services-hero.jpg'}
            link="/services"
          />
        </div>
        <div className="small-12 medium-3" style={{padding:'2px'}}>
          <TextOverImageThumb
            text="For Moms"
            image={'images/prenatal-hero.jpg'}
            link="/formoms"
          />
        </div>
        <div className="small-12 medium-3" style={{padding:'2px'}}>
          <TextOverImageThumb
            text="About Us"
            image={'images/about-hero.jpg'}
            link="/about"
          />
        </div>
        <div className="small-12 medium-3" style={{padding:'2px'}}>
          <TextOverImageThumb
            text="Online Options"
            image={'images/online-hero.jpg'}
            link="/online"
          />
        </div>
      </div>
      <div className="small-max-width-container centered-text section-padding" style={{paddingBottom: "0px"}}>
        <CenteredParagraph
          title={"Welcome to Pilates Avenue Los Gatos"}
          description={"We are a studio that teaches classical Pilates, that is, the way that Joseph Pilates designed it -- as a rigorous full-body exercise that addresses what your body needs. We seek to stay close to Joseph Pilates' original work and use equipment that is built to his specifications. We welcome bodies of all shapes and sizes. Whether you're already fit or just starting to exercise again, we can help you build strength, stamina and flexibility. Join us at Pilates Avenue and you'll find that Pilates is more than a way to exercise, it's a way of life. "}
        />
      </div>
      <div className="small-max-width-container small-padding" style={{maxWidth:"500px", paddingTop:"20px"}}>
        <VideoBox video="/logo-build.mp4" hideControls />
      </div>
      <div className="section-padding max-width-container">
        <div className="white-background">
          <TextAndImage
            ratio={'square'}/*square, rectangle*/
            direction={'right'}/*left, right*/
            image={'images/contact-square.jpg'}
            title={'Our Studio'}
            description={'Located in charming Los Gatos, Calif, we give you personalized attention in a private comfortable setting. Here, you can focus exclusively on your customized workout. We use Gratz equipment, the original manufacturer of Pilates apparatus. Designed from specifications by Joseph Pilates himself, the equipment maximizes the benefits you\'ll reap from practicing Pilates.'}
            button={true}/*true, false*/
            buttonText={'Learn More'}
            buttonLink={'/about'}
          />
        </div>
      </div>

    </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/index.js